export default "__VITE_ASSET__5bbefff7__"